import React, { Component } from 'react'
import { IMG } from '../../themes'
import { BUTTON } from './style'
export class ButtonLogin extends Component {
  render () {
    const {
      name,
      onClick,
      className = '',
      disabled,
      icon,
      classIcon,
      svg
    } = this.props
    return (
      <BUTTON
        className={className}
        onClick={disabled ? () => {} : onClick}
        disabled={disabled}
      >
        {
          icon &&
            <img
              className={`icon-btn ${classIcon || ''}`}
              src={IMG[icon]}
              alt='icon-btn'
            />
        }
        {
          svg
        }
        {name}
      </BUTTON>
    )
  }
}
